module.exports = __webpack_public_path__ + "static/img/95011C_2_3_R_20190322_fit.9c58ab1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/95011C_2_3_R_20190322_fit.png
// module id = MP7J
// module chunks = 0